import "./login.css";
import {useEffect, useState} from 'react';
import { useParams} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import axios from "axios";

const apiUrl = process.env?.REACT_APP_API_URL || "";
let urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";
const Recovery = () => {

    const {token} = useParams();
    const [t] = useTranslation("authenticate");
    const [exist, setExist] = useState(false);

    const [buttonState, setButtonState] = useState(false);
    const [buttonContent, setButtonContent] = useState(t("buttons.invitation"))
    const spinButton = <FontAwesomeIcon icon="circle-notch" className="fa-spin"/>
    const textButton = t("buttons.change-passwd")
    const [passwords, setPasswords] = useState({password: "", password2: ""});
    const [iconPass, setIconPass] = useState(<FontAwesomeIcon icon="eye"/>)

    const [inputType, setInputType] = useState('password');
    const [activeError, setActiveError] = useState(false)
    const [passwordError, setPasswordError] = useState(false)
    const [tokenError, setTokenError] = useState(false)
    const [messageConfirmed, setMessageConfirmed] = useState(false)
    document.body.style.height = "100%";
    const toggleInput = () => {
        if (inputType === 'password') {
            setInputType('text')
            setIconPass(<FontAwesomeIcon icon="eye-slash"/>)
        } else {
            setInputType('password')
            setIconPass(<FontAwesomeIcon icon="eye"/>)
        }
    }

    const handleChange = (event) => {
        const {name, value} = event.target;
        setPasswords((data) => ({...data, [name]: value}));
    };
    const now = new Date();


    const handleSubmit = (e) => {
        e.preventDefault();
        setPasswordError(false)
        setButtonState(true);
        setButtonContent(spinButton);

        if (passwords.password === passwords.password2) {
            axios.post(`${apiUrl}/api/invitation/create/`,
                {token: token, password: passwords.password})
                .then((resp) => {
                    setExist(false)
                    setMessageConfirmed(true)
                    setButtonState(false);
                    setButtonContent(textButton);
                }).catch(error => {
                setActiveError(true)
            })
        } else {
            setPasswordError(true)
        }

    }


    useEffect(() => {
        axios.post(`${apiUrl}/api/invitation/token/`, {token: token}).then((resp) => {
            setExist(resp.data.status)
            setTokenError(!resp.data.status)
        }).catch(error => {
            setActiveError(true)
        })
    }, [token, setExist]);


    return (
        <div className="form-recovery w-100 m-auto">
            <form onSubmit={handleSubmit}>
                <div className="col-12 text-center">
                    <img src={urlStatic + "/images/quamtra_manager-black.svg"} style={{"width": "90%"}} alt={"logo login"}/>
                </div>
                <h1 className="h4 mb-3  mt-4 fw-normal text-center">{t("labels.invitation")}</h1>

                {exist ?
                    <p className="h5 mb-2 text-center mb-4">{t("title.change-passwd")}</p> : <> </>}

                <p className={`error-message bg-danger text-light ${activeError ? '' : 'd-none'}`}>{t("messages.error-server")}</p>
                <p className={`error-message bg-danger text-light ${passwordError ? '' : 'd-none'}`}>{t("messages.error-password")}</p>
                <p className={`error-message bg-danger text-light ${tokenError ? '' : 'd-none'}`}>{t("messages.error-token")}</p>
                {messageConfirmed ?
                    <p className="bg-success p-2 text-light text-center h5 mt-5">{t("messages.confirmed-password")}</p>
                    : <> </>}

                {exist ? <>
                    <div className="input-group input-group-sm has-validation">
                        <div className="form-floating">
                            <input type={inputType} className="form-control"
                                   value={passwords.password}
                                   onChange={handleChange}
                                   name="password"
                                   required
                                   id="password"/>
                            <label htmlFor="password">{t("labels.password")}</label>
                        </div>
                        <button className="btn btn-outline-secondary" type="button" onClick={toggleInput}>
                            {iconPass}
                        </button>
                    </div>


                    <div className="input-group input-group-sm has-validation mt-4">
                        <div className="form-floating">
                            <input type={inputType} className="form-control"
                                   value={passwords.password2}
                                   onChange={handleChange}
                                   name="password2"
                                   required
                                   id="password2"/>
                            <label htmlFor="password2">{t("labels.change-passwd")}</label>

                        </div>

                    </div>
                    <button className="btn btn-primary w-100 py-2 mt-4"
                            type="submit"
                            disabled={buttonState}
                    >
                        {buttonContent}
                    </button>

                </> : <> </>}

                <a href="/login/" className="text-center w-100 d-inline-block py-2 mt-3">
                    {t("buttons.return")}
                </a>

                <p className="mt-4 mb-3 text-body-secondary text-center">&copy;{now.getFullYear()}</p>
            </form>
        </div>
    )
};
export default Recovery;

